/*
 * Copyright (c) 2025 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { constants } from "../constants/Constants";
import { radiusEndpointBase, urlBase } from "../constants/Endpoint";

const devDomain = constants.debug || constants.server === "stage" ? null : null;
export const isCustomDomain = () => {
  const domain = window.location.hostname;
  if (!domain) {
    return false;
  }

  if (domain === "localhost" || domain === urlBase.slice(8) || domain.includes("smartwifi.ai")) {
    return devDomain !== null;
  }

  return true;
}
export const getCustomDomain = () => {
  return devDomain ?? window.location.hostname;
}

export const getCustomDomainOrigin = () => {
  if (devDomain) {
    return `https://${devDomain}`;
  }

  return window.location.origin;
}

export const getCustomDomainRoot = () => {
  return getCustomDomain()?.split(".").slice(1).join(".");
}

export const customDomainLogo = () => {
  return radiusEndpointBase + "branding/logo/image" + (devDomain ? `?domain=${devDomain}` : '');
}

export const customDomainFavicon = () => {
  return radiusEndpointBase + "branding/favicon/image" + (devDomain ? `?domain=${devDomain}` : '');
}

export const getCustomDomainLogo = (id) => {
  if (!id) { return null }
  return radiusEndpointBase + `branding/logo/image/get?id=${id}`;
}

export const getCustomDomainFavicon = (id) => {
  if (!id) { return null }
  return radiusEndpointBase + `branding/favicon/image/get?id=${id}`;
}